import { EventEmitter, Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';

import { AdditionalButton, FilterItem, TopPanelConfig } from './top-panel';
import { TopPanelConstants } from './top-panel.constants';

@Injectable()
export class TopPanelService {
	private opts: Array<FilterItem> = [
		<FilterItem>{ key: 'dateFilter', label: 'Date Updated', active: true, show: true },
		<FilterItem>{ key: 'azFilter', label: 'A-Z', active: false, show: true }
	];

	private activeFilter: FilterItem;
	private _showSortingPanel: Object = { on: false };
	private _showButtonSection: Object = { on: true };

	// Observable
	public onFilterChange: EventEmitter<FilterItem> = new EventEmitter<FilterItem>();

	public setAdditionalButton: EventEmitter<AdditionalButton> = new EventEmitter<AdditionalButton>();

	constructor(private contentService: ContentService) {
		this.activeFilter = this.opts[0];
	}

	// Getter / Setter
	public get getFilters(): Array<FilterItem> {
		return this.opts;
	}

	public setFilterStatus(config: Array<Object>): any {
		this.opts.forEach(opt => {
			config.forEach(item => {
				if (opt.key in item) { opt.show = item[opt.key]; }
			});
		});
		return this;
	}

	public get getActiveFilter(): FilterItem {
		return this.activeFilter;
	}

	public getFilterByKey(key: string): FilterItem {
		return this.opts.find((filter: FilterItem) => filter.key === key);
	}

	public setActiveFilter(key: string, emitEvent: boolean = true): any {
		if (this.activeFilter.key === key) { return this; }

		this.opts.forEach(item => {
			if (key === item.key) {
				item.active = true;
				this.activeFilter = item;
			} else { item.active = false; }
		});
		// Event emission
		if (emitEvent) {
			this.onFilterChange.emit(this.activeFilter);
		}
		return this;
	}

	public getShowSortingPanel(): Object {
		return this._showSortingPanel;
	}

	public getShowButtonSection(): Object {
		return this._showButtonSection;
	}

	public set showSortingPanel(flag: boolean) {
		this._showSortingPanel['on'] = flag;
	}

	public set showButtonSection(flag: boolean) {
		this._showButtonSection['on'] = flag;
	}

	public showAllFilterOptions(): any {
		this.opts.forEach(opt => (opt.show = true));
		return this;
	}

	public constructTopPanelConfigObject(title: string): TopPanelConfig {
		if (title.trim() === '') {
			throw Error('Top panel title can not be set to blank');
		}

		// -- Top panel config object
		const topPanelConfig: TopPanelConfig = {
			title: {
				key: TopPanelConstants.TITLE_KEY,
				label: this.contentService.get(TopPanelConstants.TITLE_KEY, title)
			},

			filters: {
				dateFilter: {
					key: TopPanelConstants.FILTER_KEYS.dateFilter.key,
					label: this.contentService.get(TopPanelConstants.FILTER_KEYS.dateFilter.key, TopPanelConstants.FILTER_KEYS.dateFilter.label)
				},
				azFilter: {
					key: TopPanelConstants.FILTER_KEYS.azFilter.key,
					label: this.contentService.get(TopPanelConstants.FILTER_KEYS.azFilter.key, TopPanelConstants.FILTER_KEYS.azFilter.label)
				}
			},

			icon: {
				key: TopPanelConstants.TITLE_ICON_KEY,
				icon: this.contentService.get(TopPanelConstants.TITLE_ICON_KEY, TopPanelConstants.TITLE_ICON)
			},

			filterText: {
				key: TopPanelConstants.FILTER_TEXT_KEY,
				label: this.contentService.get(TopPanelConstants.FILTER_TEXT_KEY, TopPanelConstants.FILTER_TEXT_LABEL)
			},

			button: {
				key: TopPanelConstants.BUTTON_LABEL_KEY,
				label: this.contentService.get(TopPanelConstants.BUTTON_LABEL_KEY, TopPanelConstants.BUTTON_LABEL_LABEL),
				href: null
			}
		};

		this.updateFilterLabels(topPanelConfig.filters);
		return topPanelConfig;
	}

	public updateFilterLabels(filters: Object): void {
		this.opts.forEach((filter: FilterItem) => {
			filter.label = filters[filter.key]['label'];
		});
	}
}
